import { ApexOptions } from 'apexcharts';
import ReactApexChart from 'react-apexcharts';

import usePostgreFollowUpWidgetData from '../../../../../features/composableAnalytics/DerivedCharts/followUps/hooks/usePostgreFollowUpWidgetData';
import { IPostgresFollowUpDTO } from '../types/postgresFollowUpDTO';
import { IFollowUpWidgetProp } from '../types/postgresFollowUpWidgetProp';
import { defaultFollowUpWidgetData } from '../utils/followUpHelper';

const FollowUpStackedBarChartPostgres = ({ query, title }: IFollowUpWidgetProp) => {
  const { widgetData } = usePostgreFollowUpWidgetData<IPostgresFollowUpDTO>(
    query,
    defaultFollowUpWidgetData
  );

  const options: ApexOptions = {
    title: {
      text: title,
    },
    chart: {
      stacked: true,
      toolbar: {
        show: false,
      },
    },
    yaxis: {
      title: { text: 'Count of Follow Ups' },
    },
    xaxis: {
      categories: widgetData.result?.categories,
      type: 'datetime',
      title: {
        text: title,
        offsetY: 5,
      },
      labels: {
        datetimeUTC: false,
      },
    },
    stroke: {
      width: 1,
    },
    legend: {
      position: 'top',
      horizontalAlign: 'left',
      offsetX: 50,
    },
    dataLabels: {
      enabled: false,
    },
  };

  return (
    <ReactApexChart
      options={options}
      series={widgetData.result?.series as ApexAxisChartSeries}
      type="bar"
      width="100%"
      height="100%"
    />
  );
};

export default FollowUpStackedBarChartPostgres;
